import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import { EventUpgradeIds } from "../config/upgrades";
import EventTileEntity from "../EventTileEntity";

class RaftBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.FISHING;

	public static readonly frameName = FrameName.RAFT;

	public get range(): number | null {
		if (!super.range) return null;

		let range = super.range;

		// Apply upgrades
		range += getUpgradeCurrentReplaceValueById(EventUpgradeIds.fi_sail);

		return range;
	}
}

export default RaftBuildingTileEntity;
